import { AriaRadioGroupProps, AriaRadioProps } from '@react-types/radio'
import { PropsWithChildren, ReactNode } from 'react'

export interface RadioGroupProps extends PropsWithChildren<AriaRadioGroupProps> {
  className?: string
}

export interface ClassNames {
  selected: string
  hovered: string
  focused: string
}

export enum Variant {
  GREEN = 'green',
  BLUE = 'blue',
}

export interface RadioProps extends Omit<AriaRadioProps, 'children'> {
  variant?: Variant
  className?: string
  hideRadio?: boolean
  classNames?: Partial<ClassNames>
  rightAligned?: boolean
  children:
    | ReactNode
    | (({
        isFocusVisible,
        isSelected,
        isHovered,
      }: {
        isFocusVisible: boolean
        isSelected: boolean
        isHovered: boolean
      }) => ReactNode)
  size?: number
}

export interface RadioBulletProps {
  isSelected?: boolean
  isFocusVisible?: boolean
  isDisabled?: boolean
  rightAligned?: boolean
  size?: number
  color?: string
}
